import React from "react";
import { Breadcrumb } from "antd";
import { Link, useNavigate } from "react-router-dom";
import svg5 from "../assets/svg/svg5.svg";
import svg4 from "../assets/svg/svg4.svg";

export default function BreadCrumb({ breadcrumbs = [] }) {
  const navigate =  useNavigate()
  return (
    <Breadcrumb className="!flex !items-center" separator={<img src={svg5} alt="separator" />}>
    <Breadcrumb.Item>
      <Link to="/dashboard-main">Home</Link>
    </Breadcrumb.Item>
    {breadcrumbs?.map((item, index) => {
      const isLast = index === breadcrumbs?.length - 1;
      
     
      const backSteps = -(breadcrumbs?.length - index - 1);  
  
      return (
        <Breadcrumb.Item key={index}>
          {isLast ? (
            item?.title
          ) : item?.path === "back" ? (
            <span
              className="cursor-pointer"
              onClick={() => navigate(backSteps)}
            >
              {item?.title}
            </span>
          ) : (
            <Link to={item?.path}>{item?.title}</Link>
          )}
        </Breadcrumb.Item>
      );
    })}
  </Breadcrumb>
  

  );
}
